import React from 'react';
import {Loader} from 'lucide-react';

const LoaderOverlay = ({children, loading = false, showSpinner = true}) => {
	return (
		<>
			<div
				className={`relative transition-opacity duration-300 ${
					loading ? 'opacity-30 pointer-events-none' : ''
				}`}
			>
				{loading && (
					<div className="absolute inset-0 m-auto w-5 h-5">
						{showSpinner && <Loader className="size-5 animate-spin" />}
					</div>
				)}
				{children}
			</div>
		</>
	);
};

export default LoaderOverlay;
